export const DEFAULT_DESKTOP_BLOCK_ORDER = ['actions', 'map', 'rules', 'cards', 'mythos'] as const;
export type DesktopBlock = typeof DEFAULT_DESKTOP_BLOCK_ORDER[number];
export const DESKTOP_BLOCK_LABELS: Record<DesktopBlock, string> = {
  actions: 'Actions', map: 'Map', rules: 'Rules', cards: 'Cards', mythos: 'Latest Mythos',
};

export function normalizeDesktopBlockOrder(value: unknown): DesktopBlock[] {
  const known = Array.isArray(value) ? value.filter((entry): entry is DesktopBlock =>
    DEFAULT_DESKTOP_BLOCK_ORDER.includes(entry)) : [];
  return Array.from(new Set([...known, ...DEFAULT_DESKTOP_BLOCK_ORDER]));
}
